// loading this file will tell webpack under what prefix to look for assets
// NOTE: this should happen early in the app lifecycle, so webpack can resolve
// asset URLs correctly
// ref [http://webpack.github.io/docs/configuration.html#output-publicpath]

import config from './config';

const { WEBPACK_PUBLIC_PATH, BUILD, BRANCH } = config;

// Only master builds uploads assets externally
__webpack_public_path__ = (WEBPACK_PUBLIC_PATH && BRANCH === 'master') // eslint-disable-line camelcase, no-undef
  ? `${WEBPACK_PUBLIC_PATH}${BUILD}/prod/`
  : '/assets/';



// WEBPACK FOOTER //
// ./src/set-public-path.js